import { Organization, OrganizationName } from 'constants/organization/types';
import Spoctox from 'assets/images/spoctox-logo.png';
import YubiLogo from 'assets/images/yubi-logo-large-color.svg';
import dayjs from 'dayjs';

const currentYear = dayjs().format('YYYY');
export const collections: Organization = {
    name: OrganizationName.COLLECTIONS,
    brand: 'Spocto',
    email: 'help@spocto.com',
    logo: Spoctox,
    copyrights: `All Rights Reserved spocto ${currentYear}`,
    terms: 'https://spocto.com/terms-of-use/',
    website: 'https://spocto.com',
    socials: {
        fb: 'https://en-gb.facebook.com/spocto',
        tweeter: 'https://twitter.com/_spocto',
        linkedin: 'https://www.linkedin.com/company/spocto/',
    },
    signInUrl: process.env.REACT_APP_SPOCTO_HOST,
};

export const yubi: Organization = {
    name: OrganizationName.YUBI,
    brand: 'Yubi',
    email: 'support@go-yubi.com',
    logo: YubiLogo,
    copyrights: `${currentYear} Copyright Yubi.com`,
    website: 'https://go-yubi.com',
    terms: 'https://www.go-yubi.com/tnc/',
    socials: {
        fb: 'https://www.facebook.com/credavenue/',
        tweeter: 'https://twitter.com/Yubi_fin',
        linkedin: 'https://www.linkedin.com/company/go-yubi/',
    },
    signInUrl: process.env.REACT_APP_MP_HOST,
};

export const organizations = {
    [OrganizationName.COLLECTIONS]: collections,
    [OrganizationName.YUBI]: yubi,
};
